/**
 * DocumentAuthServicesPage — CRUD hub for "توثيق المستندات" services.
 * Thin wrapper — all logic lives in <CategoryServicesPage />.
 */
import { Stamp } from 'lucide-react';
import CategoryServicesPage from './CategoryServicesPage';

const DOC_AUTH_TYPE_OPTIONS = [
  { value: 'notary',            labelAr: 'كاتب العدل',        labelEn: 'Notary Public' },
  { value: 'mofa',              labelAr: 'وزارة الخارجية',    labelEn: 'MOFA' },
  { value: 'embassy',           labelAr: 'السفارات',          labelEn: 'Embassies' },
  { value: 'tenancy',           labelAr: 'عقود إيجار (إيجاري)', labelEn: 'Tenancy (Ejari)' },
  { value: 'translation',       labelAr: 'ترجمة معتمدة',      labelEn: 'Certified Translation' },
  { value: 'power_of_attorney', labelAr: 'وكالات قانونية',    labelEn: 'Power of Attorney' },
  { value: 'other',             labelAr: 'أخرى',              labelEn: 'Other' },
];

const CONFIG = {
  apiPath: '/api/document-auth-services',
  docsServiceType: 'document_auth_services',
  listPath: '/control/cloudgm/document-auth',
  typeOptions: DOC_AUTH_TYPE_OPTIONS,
  defaultServiceType: 'notary',
  accent: '#A855F7', // purple-500
  accentTw: {
    icon: 'text-purple-400',
    bg: 'bg-purple-500/10',
    border: 'border-purple-500/20',
    switchOn: 'data-[state=checked]:bg-purple-500',
    hoverBorder: 'hover:border-purple-500/50',
    hoverBg: 'hover:bg-purple-500/20',
  },
  pageIcon: Stamp,
  titleAr: 'خدمات توثيق المستندات',
  titleEn: 'Document Authentication Services',
  subtitleAr: 'إدارة خدمات التوثيق والتصديق للمستندات الرسمية',
  subtitleEn: 'Manage document attestation and authentication services',
  backPath: '/control/cloudgm?view=printing-documents',
  dataTestidPrefix: 'doc-auth',
  breadcrumb: [
    { labelAr: 'CLOUDGM FZ LLC', labelEn: 'CLOUDGM FZ LLC', path: '/dashboard?view=cloudgm' },
    { labelAr: 'منصة العملاء',    labelEn: 'Customers Platform', path: '/dashboard?view=cloudgm&platform=customers' },
    { labelAr: 'التحكم والمعلومات (منصة العملاء)', labelEn: 'Control & Info (Customers)', path: '/control/cloudgm' },
    { labelAr: 'الطباعة وتخليص المستندات', labelEn: 'Printing & Document Clearance', path: '/control/cloudgm?view=printing-documents' },
    { labelAr: 'توثيق المستندات', labelEn: 'Document Authentication' },
  ],
};

export default function DocumentAuthServicesPage() {
  return <CategoryServicesPage config={CONFIG} />;
}
